<template>
  <el-form-item :label="i18nt('designer.setting.format')">
    <el-select v-model="optionModel.format" filterable allow-create>
      <el-option label="YYYY-MM" value="YYYY-MM"></el-option>
      <el-option label="YYYY-MM-DD" value="YYYY-MM-DD"></el-option>
      <el-option label="YYYY/MM" value="YYYY/MM"></el-option>
      <el-option label="YYYY/MM/DD" value="YYYY/MM/DD"></el-option>
      <el-option label="YYYY年MM月" value="YYYY年MM月"></el-option>
      <el-option label="YYYY年MM月DD日" value="YYYY年MM月DD日"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { watch, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';
import { parseDate, formatDate } from '@/utils/date-util.js';
import dayjs from 'dayjs';

export default {
  name: 'm-date-range-format-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const propertyMixin = useProperty();

    watch(
      () => props.optionModel.format,
      (newFormat, oldFormat) => {
        if (!props.optionModel.defaultValue) return;

        props.optionModel.defaultValue.forEach((x, i) => {
          let oldDateObj = dayjs(x, oldFormat);
          props.optionModel.defaultValue[i] = oldDateObj.format(newFormat);
        });
        propertyMixin.emitDefaultValueChange();
      }
    );

    return {
      i18nt,
      ...toRefs(props),
    };
  },
};
</script>

<style scoped></style>
